import { render, staticRenderFns } from "./TipoMedidaPantalla.vue?vue&type=template&id=8088ee0a&"
import script from "./TipoMedidaPantalla.vue?vue&type=script&lang=ts&"
export * from "./TipoMedidaPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports